export default {

  partnerReviews: (state => (partnerId, bucket = 'entities') => (
    state[bucket].partners[partnerId].partnerReviews.map(id => state.entities.partnerReviews[id])
  )),

  contactDetails: ((state, getters, rootState) => (partnerId, bucket = 'entities') => {
    if (!rootState[bucket].partners[partnerId]) {
      return [];
    }
    return rootState[bucket].partners[partnerId].contactDetails.map(id => rootState.entities.contactDetails[id])
  }),

  contactLanguages: ((state, getters, rootState) => (contactId, bucket = 'entities') => {
    if (!rootState[bucket].contacts[contactId]) {
      return [];
    }
    // console.log(contactId, rootState[bucket].contacts[contactId]);
    return rootState[bucket].contacts[contactId].languages.map(id => rootState.entities.languages[id])
  }),

  contacts: ((state, getters, rootState) => (partnerId, bucket = 'entities') => {
    if (!rootState[bucket].partners[partnerId]) {
      return [];
    }
    return rootState[bucket].partners[partnerId].contacts.map(id => rootState.entities.contacts[id])
  }),

  partnerTypes: ((state, getters, rootState) => (partnerId, bucket = 'entities') => {
    if (!rootState[bucket].partners[partnerId]) {
      return [];
    }
    return rootState[bucket].partners[partnerId].types.map(id => rootState.entities.partnerTypes[id])
  }),

  contactContactDetails: ((state, getters, rootState) => (contactId, bucket = 'entities') => {
    if (!rootState[bucket].contacts[contactId]) {
      return [];
    }
    // console.log('contactContactDetails', rootState[bucket].contacts[contactId].contactDetails);
    return rootState[bucket].contacts[contactId].contactDetails.map(id => rootState.entities.contactDetails[id])
  }),

  addPartnerDialog: (state) => { return state.addPartnerDialog },
  partnerEditDialog: (state) => { return state.partnerEditDialog },

  activePartnersIds: (state) => { return state.activePartnersIds }
};


// WEBPACK FOOTER //
// ./src/store/partners/getters.js